import React from "react";
import style from "./SwitchBtn.module.css";

const SwitchBtn = ({ isOn, handleToggle }) => {
  return (
    <div className="form-check form-switch">
      <input
        className="form-check-input"
        type="checkbox"
        role="switch"
        id="flexSwitchCheckChecked"
        style={{ width: "2.5em", height: "1.5em" }}
        onChange={handleToggle}
        checked={isOn}
      />
    </div>
  );
};

export default SwitchBtn;
